import React, { useEffect, useMemo, useState } from "react";
import { Alert, alpha, Autocomplete, Backdrop, Box, Button, Checkbox, Chip, Container, Fade, FormControlLabel, FormHelperText, Grid, IconButton, InputAdornment, Modal, Pagination, Radio, Snackbar, SnackbarContent, styled, Tab, Tabs, TextareaAutosize, TextField, Typography } from "@mui/material";
import Navigation from "./navigation";
import Footer from "./components/footer/footer";
import { btnStyle, btnStyleContrast, btnStyleOutlined, colorWhite, discountHex, fontSizeHeader, fontSizeSubHeader, fontSizeText, fontSizeTextSmall, grayHex, headerStyle, lightergrayHex, lightgrayHex, methodItemStyle, passwordTextfieldStyle, passwordToggleStyle, radioStyle, redHex, roudedIconButtonStyle, subHeaderStyle, subHeaderStyleContrast, textExtraSmallStyle, textfieldStyle, textSmallStyle, textStyle, textStyleContrast } from "../helper/style";
import { useAuth } from "../authContext";
import EditIcon from '@mui/icons-material/Edit';
import { AddressService } from "../services/customer/addressService";
import CustomerService from "../services/customer/customerService";
import logoSmile from "../assets/smile.png";
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { NumericFormat } from "react-number-format";
import noImage from "../../src/assets/no-image.png";
import { useLocation, useNavigate } from "react-router-dom";
import LiqueAccordion from "./components/liqueAccordion";
import LiqueModal from "./components/liqueModal";
import CloseIcon from '@mui/icons-material/Close';
import { capitalizeWords } from "../helper/helperFunctions";
import { format } from "date-fns";
import { QRCodeCanvas } from "qrcode.react";
import { AuthService } from "../services/customer/authService";
import CheckIcon from '@mui/icons-material/Check';
import LiqueAccordionControlled from "./components/liqueAccordionControlled";


import logoDana from "../assets/logoDana.png";
import logoOvo from "../assets/logoOvo.png";
import logoMandiri from "../assets/mandiri.png";
import logoBri from "../assets/bri.svg";
import logoBni from "../assets/bni.svg";
import logoCimb from "../assets/cimb.svg";
import logoPermata from "../assets/permata.svg";
import logoSampoerna from "../assets/sampoerna.svg";
import logoBjb from "../assets/bjb.svg";
import logoBsi from "../assets/bsi.svg";
import logoQris from "../assets/qris.svg";

const AntTabs = styled(Tabs)({
  "&. MuiButtonBase-root": {
    color: "white !important"
  },
  "& .MuiTabs-indicator": {
    backgroundColor: `white !important`, 
  },
  "& .MuiTab-root": {
    color: `${lightergrayHex} !important`,
    textTransform: "none !important", 
  },
  "& .Mui-selected": {
    color: `white !important`, 
  },
});

const ProfileComponent = ({ auth, updateProfileFn }) => {
  const [username, setUsername] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [errors, setErrors] = useState({});
  const { updateProfile } = useAuth();

  const handleChangePhoneNumber = (input) => {
    let parsed = input.replace(/\D/g,'');
    setPhoneNumber(parsed);
  }

  useEffect(() => {
    if (auth?.user) {
      setUsername(auth.user.username);
      setPhoneNumber(auth.user.phonenumber);
    }
  }, [auth]);

  const validateProfile = () => {
    let tempErrors = {};
    if (!username) {
      tempErrors.username = "Username is required";
    }
    if (!phoneNumber) {
      tempErrors.phoneNumber = "Phone Number is required";
    } else if (phoneNumber.length < 10 || phoneNumber.length > 15) {
      tempErrors.phoneNumber = "Phone Number must be between 10-15 digits";
    }
    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const onClickUpdateProfile = async () => {
    if (validateProfile()) {
      const status = await updateProfileFn(username, phoneNumber);
      if (status) {
        updateProfile(username, phoneNumber);
      }
    }
  }

  return (
    <Box marginTop={3}>
      <Box marginBottom={2}>
        <Typography sx={{ ...textStyle }}>Username</Typography>
        <TextField
          sx={{ ...textfieldStyle }}
          className="input"
          placeholder="Username"
          value={username}
          autoComplete="off"
          fullWidth
          helperText={errors.username}
          FormHelperTextProps={{ sx: { color: "red" } }}
          onChange={(e) => setUsername(e.target.value)}
        />
      </Box>
      <Box marginBottom={2}>
        <Typography sx={{ ...textStyle }}>Email</Typography>
        <TextField
          sx={{ ...textfieldStyle }}
          className="input"
          type="email"
          placeholder="Email"
          value={auth?.user.email}
          autoComplete="off"
          fullWidth
          disabled
        />
      </Box>
      <Box marginBottom={2}>
        <Typography sx={{ ...textStyle }}>Phone Number</Typography>
        <TextField
          sx={{ ...textfieldStyle }}
          className="input"
          placeholder="Phone Number"
          value={phoneNumber}
          autoComplete="off"
          fullWidth
          helperText={errors.phoneNumber}
          FormHelperTextProps={{ sx: { color: "red" } }}
          onChange={(e) => handleChangePhoneNumber(e.target.value)}
        />
      </Box>
      <Grid container justifyContent="end" marginTop={2}>
        <Grid item xs={12} md={3}>
          <Button sx={{ ...btnStyle, width: "100%", borderRadius: "50px" }} onClick={onClickUpdateProfile}>
            Update Profile
          </Button>
        </Grid> 
      </Grid>
    </Box>
  )
}

const PasswordComponent = ({ updatePassword }) => {
  const [password, setPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [passwordConfirmation, setPasswordConfirmation] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showPasswordConfirmation, setShowPasswordConfirmation] = useState(false);
  const [passwordErrors, setPasswordErrors] = useState([]);

  const validateChangePassword = () => {
    let tempErrors = {};

    if (!password) {
      tempErrors.password = "Password is required";
    } else if (password.length > 255) {
      tempErrors.password = "Password can be a maximum of 255 characters";
    }

    if (!newPassword) {
      tempErrors.newPassword = "New Password is required";
    } else if (newPassword.length > 255) {
      tempErrors.newPassword = "New Password can be a maximum of 255 characters";
    }

    if (!passwordConfirmation) {
      tempErrors.passwordConfirmation = "Password Confirmation is required";
    } else if (passwordConfirmation.length > 255) {
      tempErrors.passwordConfirmation =
        "Password Confirmation can be a maximum of 255 characters";
    } else if (newPassword !== passwordConfirmation) {
      tempErrors.passwordConfirmation =
        "Password Confirmation must match the New Password";
    }

    setPasswordErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const onClickUpdatePassword = async () => {
    if (validateChangePassword()) {
      const status = await updatePassword(password, newPassword, passwordConfirmation)
      if (status) {
        setPassword("");
        setNewPassword("");
        setPasswordConfirmation("");
      }
    }
  }

  return (
    <Box>
      <Box marginTop={3}>
        <Box marginBottom={2}>
          <Typography sx={{ ...textStyle }}>Password</Typography>
          <TextField
            sx={passwordTextfieldStyle}
            placeholder="Password"
            type={showPassword ? "text" : "password"}
            value={password}
            helperText={passwordErrors.password}
            FormHelperTextProps={{ sx: { color: "red" } }}
            fullWidth
            onChange={(e) => setPassword(e.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end" sx={passwordToggleStyle}>
                  <div
                    onClick={() => setShowPassword(!showPassword)}
                    style={{ cursor: "pointer", marginTop: "3px"  }}
                  >
                    { showPassword ? <VisibilityOffIcon sx={{ color: lightgrayHex }} /> : <VisibilityIcon sx={{ color: lightgrayHex }} />}
                  </div>
                </InputAdornment>
              ),
            }}
          ></TextField>
        </Box>
        <Box marginBottom={2}>
          <Typography sx={{ ...textStyle }}>New Password</Typography>
          <TextField
            sx={passwordTextfieldStyle}
            placeholder="New Password"
            type={showNewPassword ? "text" : "password"}
            value={newPassword}
            helperText={passwordErrors.newPassword}
            FormHelperTextProps={{ sx: { color: "red" } }}
            fullWidth
            onChange={(e) => setNewPassword(e.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end" sx={passwordToggleStyle}>
                  <div
                    onClick={() => setShowNewPassword(!showNewPassword)}
                    style={{ cursor: "pointer", marginTop: "3px"  }}
                  >
                    { showNewPassword ? <VisibilityOffIcon sx={{ color: lightgrayHex }} /> : <VisibilityIcon sx={{ color: lightgrayHex }} />}
                  </div>
                </InputAdornment>
              ),
            }}
          ></TextField>
        </Box>
        <Box marginBottom={2}>
          <Typography sx={{ ...textStyle }}>Confirm Password</Typography>
          <TextField
            sx={passwordTextfieldStyle}
            placeholder="Confirm Password"
            type={showPasswordConfirmation ? "text" : "password"}
            value={passwordConfirmation}
            helperText={passwordErrors.passwordConfirmation}
            FormHelperTextProps={{ sx: { color: "red" } }}
            fullWidth
            onChange={(e) => setPasswordConfirmation(e.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end" sx={passwordToggleStyle}>
                  <div
                    onClick={() => setShowPasswordConfirmation(!showPasswordConfirmation)}
                    style={{ cursor: "pointer", marginTop: "3px"  }}
                  >
                    { showPasswordConfirmation ? <VisibilityOffIcon sx={{ color: lightgrayHex }} /> : <VisibilityIcon sx={{ color: lightgrayHex }} />}
                  </div>
                </InputAdornment>
              ),
            }}
          ></TextField>
        </Box>
        <Grid container justifyContent="end" marginTop={2}>
          <Grid item xs={12} md={3}>
            <Button sx={{ ...btnStyle, width: "100%", borderRadius: "50px" }} onClick={onClickUpdatePassword}>
              Change Password
            </Button>
          </Grid> 
        </Grid>
      </Box>
    </Box>
  );
};

const styleModal = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 1000,
  maxWidth: "70%",
  maxHeight: "80vh",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  borderRadius: "12px",
  overflowY: "auto",
  overflowX: "hidden"
};

const btnRincianStyle = {
  width: "100%",
  backgroundColor: "white",
  color: "black",
  height: "40px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  fontWeight: "bold",
  borderRadius: "100px"
}

const textHereStyle = {
  textDecoration: "underline", 
  fontWeight: "bold",
  cursor: "pointer"
}

const profileItemStyle = {
  background: "transparent",
  opacity: ".5",
  borderRadius: "8px;",
  transition: "all .1s ease-in-out",
  '&:hover': {
    background: grayHex,
  },
  cursor: "pointer",
  width: "100%",
  height: "36px",
  display: "flex",
  alignItems: "center",
  gap: "20px",
  padding: "10px",
  marginBottom: "10px"
}

const profileItemSelectedStyle = {
  background: grayHex,
  borderRadius: "8px;",
  cursor: "pointer",
  width: "100%",
  height: "36px",
  display: "flex",
  alignItems: "center",
  gap: "20px",
  padding: "10px",
  marginBottom: "10px"
}

const ProfilePage = () => {
  const { auth } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const imageUrl = process.env.REACT_APP_IMAGE_URL

  const [ShowSuccess, setShowSuccess] = useState(false);
  const [MsgSuccess, setMsgSuccess] = useState("");
  const [showError, setShowError] = useState(false);
  const [msgError, setMsgError] = useState();
  const [errors, setErrors] = useState([]);

  const [addressList, setAddressList] = useState([]);
  const [addressData, setAddressData] = useState(null);
  const [historyData, setHistoryData] = useState([]);

  const [provinces, setProvinces] = useState([]);
  const [cities, setCities] = useState([]);
  const [zipcodes, setZipcodes] = useState([]);
  const [subDistricts, setSubDistricts] = useState([]);
  const [neighborhoods, setNeighborhoods] = useState([]);
  const [selectedProvince, setSelectedProvince] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);
  const [selectedSubDistrict, setSelectedSubDistrict] = useState(null);
  const [selectedNeighborhood, setselectedNeighborhood] = useState(null);
  const [selectedZipcode, setSelectedZipcode] = useState(null);
  const [selectedAddress, setSelectedAddress] = useState("");
  const [isDefault, setIsDefault] = useState(false);
  const [addressNotes, setAddressNotes] = useState("");

  const [addressDialog, setAddressDialog] = useState(false);
  const [editAddressId, setEditAddressId] = useState(false);
  const [addAddressDialog, setAddAddressDialog] = useState(false);

  const params = new URLSearchParams(location.search);
  const availableOptions = ['profile', 'address', 'history', 'password'];
  const page = params.get("page");
  const [option, setOption] = useState(availableOptions.includes(page) ? page : "profile");
  const [historyPage, setHistoryPage] = useState(1);
  const [totalHistoryItem, setTotalHistoryItem] = useState(1);
  const [totalHistoryPage, setTotalHistoryPage] = useState(1);
  const [selectedHistory, setSelectedHistory] = useState(null);
  const [trackData, setTrackData] = useState(null);
  const [openHistoryDetail, setOpenHistoryDetail] = useState(false);
  const [openTrack, setOpenTrack] = useState(false);
  const [openPay, setOpenPay] = useState(false);
  const [currentTab, setCurrentTab] = useState('ALL');
  const [orderStatus, setOrderStatus] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [loadingTrack, setLoadingTrack] = useState(false);
  const ableToTrack = ["PAID", "PACKAGED", "ON_DELIVERY", "DELIVERED"];

  const [openDelete, setOpenDelete] = useState(false);
  const [loadingDelete, setLoadingDelete] = useState(false);

  const [ewalletDialog, setEwalletDialog] = useState(false);
  const [virtualAccountDialog, setVirtualAccountDialog] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState("");
  const [paymentChannel, setPaymentChannel] = useState("");
  const [paymentMethodDialog, setPaymentMethodDialog] = useState(false);

  const [subTotal, setSubTotal] = useState(0);
  const [deliveryFee, setDeliveryFee] = useState(0);
  const [transactionFee, setTransactionFee] = useState(0);
  const [discount, setDiscount] = useState(0);
  const [total, setTotal] = useState(0);
  const [currentPaymentRef, setCurrentPaymentRef] = useState(null);
  const [loadingUpdateMethod, setLoadingUpdateMethod] = useState(null);

  const handleOpenHistoryDetail = (order) => {
    setSelectedHistory(order);
    setOpenHistoryDetail(true);
  }

  const handleCloseHistoryDetail = () => {
    setOpenHistoryDetail(false);
    setSelectedHistory(null);
  }

  const handleOpenPay = (order) => {
    setSelectedHistory(order);
    setOpenPay(true);
  }

  const handleClosePay = () => {
    setOpenPay(false);
    setSelectedHistory(null);
  }

  const handleOpenTrack = (order) => {
    setSelectedHistory(order);
    if (order.delivery) {
      trackOrder(order.delivery.awb);
    }
    setOpenTrack(true);
  }

  const handleCloseTrack = () => {
    setOpenTrack(false);
    setSelectedHistory(null);
    setTrackData(null);
  }

  const validate = () => {
    let tempErrors = {};

    if (!selectedAddress) {
      tempErrors.address = "Address is required";
    } else if (selectedAddress.length > 90) {
      tempErrors.address = "Address can be a maximum of 90 characters";
    }

    if (!selectedCity) {
      tempErrors.city = "City is required";
    }

    if (!selectedProvince) {
      tempErrors.state = "Province is required";
    }

    if (!selectedZipcode) {
      tempErrors.zipcode = "Zipcode is required";
    } else if (selectedZipcode.length > 6) {
      tempErrors.zipcode = "Zipcode can be a maximum of 6 characters";
    }

    if (addressNotes.length > 100) {
      tempErrors.notes = "Notes can be a maximum of 100 characters";
    }

    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const getStatusColor = (key) => {
    let bg = ''
    let text = ''
  
    if (key === 'DRAFT') {
      text = lightergrayHex
      bg = 'black'
    } else if (key === 'WAITING_FOR_PAYMENT') {
      text = '#FE8A01'
      bg = '#4A2600' // very dark orange-brown
    } else if (key === 'PAID') {
      text = '#5DB7DE'
      bg = '#1C3A4A' // dark steel blue
    } else if (key === 'PACKAGED') {
      text = '#0074CC'
      bg = '#002244' // navy tone
    } else if (key === 'ON_DELIVERY') {
      text = '#9B30FF'
      bg = '#2E005C' // deep purple
    } else if (key === 'DELIVERED') {
      text = '#19B600'
      bg = '#073300' // forest green
    } else if (key === 'CANCELED') {
      text = '#E50B0B'
      bg = '#3A0000' // blood red
    }
  
    return {
      background: bg,
      color: text
    }
  };

  const getStatustext = (key) => {
    let text = ''
    if (key === 'DRAFT') {
      text = 'In Cart'
    } else if (key === 'WAITING_FOR_PAYMENT') {
      text = 'Waiting for Payment'
    } else if (key === 'PAID') {
      text = 'Waiting for Confirmation'
    } else if (key === 'PACKAGED') {
      text = 'Packaged'
    } else if (key === 'ON_DELIVERY') {
      text = 'On Delivery'
    } else if (key === 'DELIVERED') {
      text = 'Finished'
    } else if (key === 'CANCELED') {
      text = 'Canceled'
    }
  
    return text;
  };

  const activateSuccess = () => {
    setShowSuccess(true);
    setTimeout(() => {
      setShowSuccess(false);
    }, 5000);
  };

  const activateError = () => {
    setShowError(true);
    setTimeout(() => {
      setShowError(false);
    }, 5000);
  };

  const handleOpenAddressDialog = () => {
    setAddressDialog(true);
  }

  const handleCloseAddressDialog = () => {
    setAddressDialog(false);
  }

  const handleOpenAddAddress = async (address = null) => {
    fetchProvinces();
    if (address != null && address !== undefined) {
      setEditAddressId(address.id);
      fetchCities(address.province);
      fetchSubDistricts(address.province, address.district);
      fetchNeighborhoods(address.province, address.district, address.subdistrict);
      fetchZipCode(address.province, address.district, address.subdistrict, address.neighborhood);

      setSelectedAddress(address.detail);
      setSelectedProvince(address.province);
      setSelectedCity(address.district);
      setSelectedSubDistrict(address.subdistrict);
      setselectedNeighborhood(address.neighborhood);
      setSelectedZipcode(address.zipCode);
      setIsDefault(address.isDefault);
      setAddressNotes(address.notes);
    } 

    setAddAddressDialog(true);
  }

  const handleCloseAddAddress = () => {
    setAddAddressDialog(false);
    setEditAddressId(null);

    setSelectedAddress("");
    setSelectedProvince(null);
    setSelectedCity(null);
    setSelectedSubDistrict(null);
    setselectedNeighborhood(null);
    setSelectedZipcode(null);
    setIsDefault(false);
    setAddressNotes("");
  }
  
  const handleNavigation = async (nav) => {
    setCurrentTab(nav);
    setSelectedStatus(nav === "ALL" ? "" : nav);
  };

  const getStatusOrderList = async () => {
    try {
      const response = await CustomerService.getStatusOrderList();
      if (response) {
        const data = response.data.orderStatusList;
        setOrderStatus(data);
      }
    } catch (error) { 
      console.error(error);
    }
  }

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  const fetchOrderHistory = async () => {
    try {
      const response = await CustomerService.getOrderHistoryPaginate(auth?.user.phonenumber, auth?.user.id, historyPage, 5, selectedStatus);
      if (response) {
        const data = response.data;
        setHistoryData(data.orders);
        setTotalHistoryItem(data.totalItems);
        setTotalHistoryPage(data.totalPage);
      }
    } catch (error) {
      console.error(error);
    }
  }

  const trackOrder = async (awb) => {
    try {
      setLoadingTrack(true);
      const response = await CustomerService.trackOrder(awb)
      if (response) {
        const data = response.data;
        if (data?.history && Array.isArray(data?.history)) {
          data.history.reverse();
        }
        setTrackData(data);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingTrack(false);
    }
  }

  const fetchDataAddress = async () => {
    try {
      const response = await AddressService.fetchDataAddress(auth?.user.phonenumber);
      if (response) {
        const addressList = response.data.addressList
        setAddressList(addressList);

        if (addressList?.length > 0) {
          const defautAddress = addressList.find(address => address.isDefault);
          if (defautAddress) {
            setAddressData(defautAddress);
          } else {
            setAddressData(addressList[0]);
          }
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const fetchProvinces = async () => {
    try {
      const response = await AddressService.fetchProfinces();
      if (response) {
        setProvinces(response.data.provinceList);
      }
    } catch (error) {
      console.error("There was an error fetching the data!", error);
    }
  };

  const fetchCities = async (provinceId) => {
    try {
      const response = await AddressService.fetchCities(provinceId);
      if (response) {
        setCities(response.data.districtList);
      }
    } catch (error) {
      console.error("There was an error fetching the data!", error);
    }
  };

  const fetchSubDistricts = async (provinceId, cityId) => {
    try {
      const response = await AddressService.fetchSubDistricts(provinceId, cityId);
      if (response) {
        setSubDistricts(response.data.subdistrictList);
      }
    } catch (error) {
      console.error("There was an error fetching the data!", error);
    }
  };

  const fetchNeighborhoods = async (provinceId, cityId, subDistrictId) => {
    try {
      const response = await AddressService.fetchNeighborhoods(provinceId, cityId, subDistrictId);
      if (response) {
        setNeighborhoods(response.data.neighborhoodList);
      }
    } catch (error) {
      console.error("There was an error fetching the data!", error);
    }
  }

  const fetchZipCode = async (provinceId, cityId, subDistrictId, neighborhood) => {
    try {
      const response = await AddressService.fetchZipCode(provinceId, cityId, subDistrictId, neighborhood);
      if (response) {
        setZipcodes(response.data.zipCodeList);
      }
    } catch (error) {
      console.error("There was an error fetching the data!", error);
    }
  }

  const submitAddress = async () => {
    if (!validate()) return;

    try {
      let response = null;
      if (editAddressId != null) {
        response = await AddressService.updateAddress(
          auth?.user.phonenumber,
          editAddressId,
          selectedProvince,
          selectedCity,
          selectedSubDistrict,
          selectedNeighborhood,
          selectedZipcode, 
          selectedAddress,
          isDefault,
          addressNotes
        )
      } else {
        response = await AddressService.addAddress(
          auth?.user.phonenumber,
          selectedProvince,
          selectedCity,
          selectedSubDistrict,
          selectedNeighborhood,
          selectedZipcode, 
          selectedAddress,
          isDefault,
          addressNotes
        );

      }

      if (response) {
        fetchDataAddress();

        setAddAddressDialog(false);
        setSelectedAddress(null);
        setSelectedProvince(null);
        setSelectedCity(null);
        setSelectedSubDistrict(null);
        setselectedNeighborhood(null);
        setSelectedZipcode(null);
        setIsDefault(false);
        setEditAddressId(null);
        setAddressNotes("");
      }
    } catch (error) {
      console.error(error);
      setMsgError(error.response.data.message);
      activateError();
    }
  }

  const updatePassword = async (password, newPassword, passwordConfirmation) => {
    try {
      const response = await AuthService.updatePassword(
        auth?.user.id,
        password, 
        newPassword, 
        passwordConfirmation
      );
      if (response) {
        setMsgSuccess("Password Changed Successfully");
        activateSuccess();

        return true;
      }
    } catch (error) {
      console.error(error);
      if (error.request.status === 422) {
        setMsgError(error.response.data.message[0]);
        activateError();
      } else {
        setMsgError("Oops, something went wrong.");
        activateError();
      }
    }
  }

  const updateProfile = async (userName, phoneNumber) => {
    try {
      const response = await CustomerService.updateProfile(
        auth?.user.id,
        userName,
        phoneNumber
      );
      if (response) {
        console.log(response);
        setMsgSuccess("Profile Updated Successfully");
        activateSuccess();

        return true;
      }
    } catch (error) {
      console.error(error);
      if (error.request.status === 422) {
        setMsgError(error.response.data.message[0]);
        activateError();
      } else {
        setMsgError("Oops, something went wrong.");
        activateError();
      }
    }
  }

  const getPembayaran = (paymentData) => {
    if (paymentData.method === 'CASH_ON_DELIVERY') {
      return "COD";
    } else {
      switch (paymentData.channel) {
        case 'QRIS':
          return "QRIS";
        case 'OVO':
          return "OVO";
        case 'DANA':
          return "Dana";
        case 'MANDIRI':
          return "Mandiri Virtual Account";
        case 'BRI':
          return "BRI Virtual Account";
        case 'BNI':
          return "BNI Virtual Account";
        case 'CIMB':
          return "CIMB Virtuak Account";
        case 'PERMATA':
          return "Permata Virtual Account";
        case 'SAHABAT_SAMPOERNA':
          return "Sahabat Sampoerna Virtual Account";
        case 'BJB':
          return "BJB Virtual Account";
        case 'BSI':
          return "BSI Virtual Account";
        default:
          return "";
      }
    }
  }

  const deleteItem = async () => {
    if (!selectedHistory) return;
 
    setLoadingDelete(true)
    try {
      const response = await CustomerService.deleteOrder(selectedHistory.order.id)

      if (response) {
        setOpenDelete(false);
        handleCloseHistoryDetail();
        fetchOrderHistory();
      }
    } catch (error) {
      console.error(error);
      setMsgError("Cancel order failed")
    } finally {
      setLoadingDelete(false)
    }
  }

  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const setPaymentData = (paymentMethod, paymentChannel) => {
    setPaymentMethod(paymentMethod);
    setPaymentChannel(paymentChannel);
    
    getTransactionFeePreview();
  }
  
  const setEwalletPaymentData = (paymentChannel) => {
    setPaymentMethod("EWALLET");
    setPaymentChannel(paymentChannel);

    getTransactionFeePreview();
    setEwalletDialog(false);
  }

  const setVAPaymentData = (paymentChannel) => {
    setPaymentMethod("VIRTUAL_ACCOUNT");
    setPaymentChannel(paymentChannel);

    getTransactionFeePreview();
    setVirtualAccountDialog(false);
  }

  const handleOpenChangePaymentMethod = (payment) => {
    setSubTotal(payment.price);
    setDeliveryFee(payment.deliveryFee);
    setDiscount(payment.discount);
    setTotal(payment.totalPrice);
    setTransactionFee(payment.transactionFee);
    setCurrentPaymentRef(payment.referenceId);
    setPaymentMethod(payment.method);
    setPaymentChannel(payment.channel);

    setPaymentMethodDialog(true);
  }

  const handleCloseChangePaymentMethod = () => {
    setPaymentMethodDialog(false);

    setSubTotal(0);
    setDeliveryFee(0);
    setDiscount(0);
    setTotal(0);
    setTransactionFee(0);
    setCurrentPaymentRef(null);
    setPaymentMethod("");
    setPaymentChannel("");
  }

  const getTransactionFeePreview = async () => {
    try {
      const response = await CustomerService.getTransactionFeePreview(
        paymentMethod, paymentChannel, currentPaymentRef
      );

      if (response) {
        const data = response.data;
        setSubTotal(data.price);
        setDeliveryFee(data.deliveryFee);
        setDiscount(data.discount);
        setTransactionFee(data.transactionFee);
        setTotal(data.totalPrice);
      }
    } catch (error) {
      console.error(error);
      setMsgError("Oops, something went wrong.");
      activateError();
    }
  }

  const changePaymentMethod = async () => {
    try {
      setLoadingUpdateMethod(true);
      const response = await CustomerService.changePaymentMethod(
        selectedHistory.order.id,
        paymentMethod,
        paymentChannel,
        auth.user.username
      );

      if (response) {
        handleCloseChangePaymentMethod();
        handleClosePay();
        fetchOrderHistory();
      }
    } catch(error) {
      console.error(error)
      setMsgError("Oops, something went wrong when changing payment method.");
      activateError();
    } finally {
      setLoadingUpdateMethod(false);
    }
  }

  useEffect(() => {
    if (availableOptions.includes(page)) {
      setOption(page)
    } else {
      setOption("profile");
    }
  
    window.scrollTo(0, 0);
  }, [location.search]);

  useEffect(() => {
    if (auth?.user) {
      fetchOrderHistory();
    }
  }, [historyPage, selectedStatus]);

  useEffect(() => {
    if (auth?.user) {
      fetchDataAddress();
      getStatusOrderList();
      fetchOrderHistory();
    }
  }, [auth])

  const AddressComponent = () => {
    return (
      <Box marginTop={3}>
        {
          addressList.length > 0 ? (
            <Box>
              {
                addressList.map(address => (
                  <Box position="relative"> 
                    <Box 
                      key={address.id}
                      sx={{ color: "white", padding: 2, borderBottom: `2px solid ${lightgrayHex}` }}
                    >
                      <Grid container spacing={2} textAlign={"left"} justifyContent="space-between">
                        
                        <Grid item xs={8}>
                          <Grid container>
                            <Grid item xs={12}>
                              <Typography sx={{ ...textSmallStyle, fontWeight: "bold" }}>
                                {address.detail}
                              </Typography>
                            </Grid>
                            <Grid item xs={12}>
                              <Typography sx={{ ...textSmallStyle }}>
                                {address.province}, {address.district},{" "}
                                {address.subdistrict}, {address.neighborhood},{" "}
                                {address.zipCode}
                              </Typography>
                            </Grid>
                            <Grid item xs={12}>
                              <Typography sx={{ ...textExtraSmallStyle }}>
                                Notes: {address.notes || '-'}
                              </Typography>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Box>

                    
                    <IconButton sx={{ color: "white", position: "absolute", right: "20px", top: "30%" }} onClick={() => handleOpenAddAddress(address)}>
                      <EditIcon />
                    </IconButton>
                  </Box>
                ))
              }
              <Box marginTop={2}>
                <Grid container spacing={2}>
                  <Grid item xs={12} textAlign="center">
                    <Button
                      onClick={handleOpenAddAddress}
                      style={{ ...btnStyle }}
                    >
                      Add Address
                    </Button>
                  </Grid>
                </Grid>
              </Box>
            </Box>
          ) : (
            <Box>
              <Typography sx={{ ...textStyle }}>
                You don't have any saved addresses yet.
              </Typography>
              <Box sx={{ mt: 2 }} textAlign="center">
                <Button
                  onClick={handleOpenAddAddress}
                  style={{...btnStyle}}
                >
                  Add Address
                </Button>
              </Box>
            </Box>
          )
        }
      </Box>
    );
  };

  const HistoryComponent = () => {
    return (
      <Box marginTop={3}>
        
        <Box
          sx={{
            borderBottom: 1,
            borderColor: "divider",
            paddingTop: "24px",
          }}
        >
          <AntTabs
            value={value}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="auto"
            textColor="secondary"
            indicatorColor="secondary"
          >
            <Tab label={`All Orders`} {...a11yProps(0)} 
              onClick={() => handleNavigation("ALL")} />
            {
              orderStatus.filter((status) => status.key !== 'DRAFT').map((status, index) => (
                <Tab key={status.key} label={getStatustext(status.key)} {...a11yProps(index + 1)}
                  onClick={() => handleNavigation(status.key)} />
              ))
            }
          </AntTabs>
        </Box>

        {
          historyData.map(order => (
            <Box sx={{ padding: "20px", marginBottom: "20px", borderRadius: "16px", background: grayHex }} key={order.order.id}>
              <Grid container spacing={3}>
                <Grid item xs={12} display="flex" gap="20px" flexWrap="wrap">
                  <Box>
                    <Typography sx={{ ...textStyle }}>{format(new Date(order.order.createdDate), "dd MMMM yyy")}</Typography>
                  </Box>
                  <Box>
                    <Typography sx={{ ...textStyle }}>{order.order.id}</Typography>
                  </Box>
                  <Box>
                    <Chip 
                      sx={{ ...textExtraSmallStyle, height: "25px" }}
                      label={getStatustext(order.order.status?.key)} 
                      style={getStatusColor(order.order.status?.key)}
                    ></Chip>
                  </Box>
                </Grid>

                <Grid item xs={12}>
                  <Grid container>
                    <Grid item xs={12} md={2}>
                        <img
                          src={
                            order.order.itemList[0].images?.length <= 0 || order.order.itemList[0].images == null
                            ? noImage
                            : `${imageUrl}${order.order.itemList[0].images[0]}`
                        }
                        alt={order.order.itemList[0].name}
                        style={{
                          width: "100%",
                          maxWidth: "50px",
                          aspectRatio: "1 / 1",
                          objectFit: "cover",
                          marginRight: "3%",
                          borderRadius: "8px"
                        }}
                      ></img>
                    </Grid>

                    <Grid item xs={12} md={6}>
                      {
                        order.order.itemList[0]?.brand && (
                          <>
                            <img 
                              src={order.order.itemList[0]?.brand.images == null ? noImage : `${imageUrl}${order.order.itemList[0]?.brand.images[0]}`}
                              alt={order.order.itemList[0]?.brand.title}
                              style={{ width: "80px", maxWidth: "30%", aspectRatio: "1 / 1", objectFit: "contain" }}
                            />
                          </>
                        )
                      }
                      <Typography sx={{ ...textStyle }} fontWeight="bold">
                        {order.order.itemList[0]?.name}, Size {order.order.itemList[0]?.variant?.size}
                      </Typography>
                      <Typography sx={{ ...textSmallStyle, color: lightergrayHex }}>
                        Total products: {order.order.itemList.length}
                      </Typography>
                    </Grid>

                    <Grid item xs={12} md={4} display="flex" alignItems="center">
                      <Box sx={{ marginTop: {xs: "10px", md: "unset"} }}>
                        <Typography sx={{ ...textSmallStyle, color: lightergrayHex }}>
                          Total Price
                        </Typography>
                        <Typography sx={{ ...textStyle, fontWeight: "bold" }}>
                          {
                            order.payment.length > 0 ? (
                              <>
                                <NumericFormat
                                  value={order.order?.subTotal}
                                  displayType={"text"}
                                  thousandSeparator="."
                                  decimalSeparator=","
                                  prefix={"RP "}
                                />
                              </>
                            ) : (
                              <>-</>
                            )
                          }
                        </Typography>
                      </Box>
                    </Grid>

                    <Grid item xs={12} marginTop={2}>
                      <Grid container justifyContent="end" columnSpacing={2}>
                        <Grid item xs={6} md={3}>
                          <Button sx={{ ...btnStyleOutlined, width: "100%", borderRadius: "50px" }} onClick={() => handleOpenHistoryDetail(order)}>
                            <Typography sx={{ ...textStyle }}>View Details</Typography>
                          </Button>
                        </Grid>
                        {
                          ableToTrack.includes(order.order.status.key) && (
                            <Grid item xs={6} md={3}>
                              <Button sx={{ ...btnStyle, width: "100%", borderRadius: "50px" }} onClick={() => handleOpenTrack(order)}>
                                <Typography sx={{ ...textStyleContrast }}>Track Order</Typography>
                              </Button>
                            </Grid>
                          )
                        }
                        {
                          order.order.status.key === "WAITING_FOR_PAYMENT" && (
                            <Grid item xs={6} md={3}>
                              <Button sx={{ ...btnStyle, borderRadius: "50px", width: "100%" }} onClick={() => handleOpenPay(order)}>
                                <Typography sx={{ ...textStyleContrast }}>Pay</Typography>
                              </Button>
                            </Grid>
                          )
                        }
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Box>
          ))
        }
        {
          historyData.length <= 0 ? (
            <Box>
              <Typography sx={{ ...textStyle, textAlign: "center" }}>No Orders Yet</Typography>
            </Box>
          ) : (
            <Box display="flex" justifyContent="center">
              <Pagination sx={{ 
                  '& .MuiPaginationItem-root': {
                    color: 'white', 
                  },
                  '& .MuiPaginationItem-icon': {
                    color: 'white', 
                  },
                  '& .Mui-selected': {
                    backgroundColor: 'white !important', 
                    color: 'black', 
                  },
                }} 
                size="small"
                count={totalHistoryPage} 
                page={historyPage}
                onChange={(_event, page) => setHistoryPage(page)} />
            </Box>
          )
        }
      </Box>
    );
  };

  return (
    <>
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        open={ShowSuccess}
        autoHideDuration={3000}
        onClose={() => setShowSuccess(false)}
      >
        <SnackbarContent
          sx={{ backgroundColor: "#19B600" }} 
          message={MsgSuccess}/>
      </Snackbar>

      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        open={showError}
        autoHideDuration={3000}
        onClose={() => setShowError(false)}
      >
        <SnackbarContent 
          sx={{ backgroundColor: "#E50B0B" }} 
          message={msgError}/>
      </Snackbar>

      <Navigation />

      <Box sx={{ width: "100%", background: "black", paddingBottom: "50px", minHeight: "80vh", marginTop: "60px" }}>
        <Container component="main" maxWidth="xl" sx={{ marginBottom: "50px" }}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={3} sx={{ padding: {xs: 'unset', md: 3} }}>
              <Typography sx={{ ...headerStyle }}>PROFILE</Typography>
              
              <Box display="flex" alignItems="center" gap="20px" marginTop={3} padding={1}>
                <Box sx={{ borderRadius: "100px", width: "50px", height: "50px", display: "flex", justifyContent: "center", alignItems: "center", background: "#1D1D24" }}>
                  <PersonOutlineIcon sx={{ ...colorWhite }} />
                </Box>
                <Box>
                  <Typography sx={{ ...textStyle }}>{auth?.user.username}</Typography>
                  <Typography sx={{ ...textSmallStyle }}>{auth?.user.email}</Typography>
                </Box>
              </Box>   

              <Box marginTop={3} sx={{ display: { xs: "none", md: "block"} }}>
                <Box sx={option === 'profile' ? profileItemSelectedStyle : profileItemStyle} onClick={() => setOption('profile')}>
                  <PersonOutlineIcon sx={{ ...colorWhite }} />
                  <Typography sx={{ ...textStyle }}>My Profile</Typography>
                </Box>
                <Box sx={option === 'address' ? profileItemSelectedStyle : profileItemStyle} onClick={() => setOption('address')}>
                  <HomeOutlinedIcon sx={{ ...colorWhite }} />
                  <Typography sx={{ ...textStyle }}>Shipping Addresses</Typography>
                </Box>
                <Box sx={option === 'history' ? profileItemSelectedStyle : profileItemStyle} onClick={() => setOption('history')}>
                  <MailOutlineIcon sx={{ ...colorWhite }} />
                  <Typography sx={{ ...textStyle }}>My Orders</Typography>
                </Box>
                <Box sx={option === 'password' ? profileItemSelectedStyle : profileItemStyle} onClick={() => setOption('password')}>
                  <LockOutlinedIcon sx={{ ...colorWhite }} />
                  <Typography sx={{ ...textStyle }}>Change Password</Typography>
                </Box>
              </Box>

              <Box marginTop={3} sx={{ display: { xs: "block", md: "none"} }}>
                <LiqueAccordionControlled
                  title={
                    <Box display="flex" alignItems="center" gap="10px">
                      <PersonOutlineIcon sx={{ ...colorWhite }} /> My Profile
                    </Box>
                  } 
                  onChange={() => setOption("profile")}
                  defaultExpanded={option === 'profile'}>
                  <ProfileComponent auth={auth} updateProfileFn={updateProfile} />
                </LiqueAccordionControlled>
                <LiqueAccordionControlled
                  title={
                    <Box display="flex" alignItems="center" gap="10px">
                      <HomeOutlinedIcon sx={{ ...colorWhite }} /> Shipping Addresses
                    </Box>
                  } 
                  onChange={() => setOption("address")}
                  defaultExpanded={option === 'address'}
                >
                  <AddressComponent />
                </LiqueAccordionControlled>
                <LiqueAccordionControlled
                  title={
                    <Box display="flex" alignItems="center" gap="10px">
                      <MailOutlineIcon sx={{ ...colorWhite }} /> My Orders
                    </Box>
                  }  
                  onChange={() => setOption("history")}
                  defaultExpanded={option === 'history'}
                >
                  <HistoryComponent />
                </LiqueAccordionControlled>
                <LiqueAccordionControlled
                  title={
                    <Box display="flex" alignItems="center" gap="10px">
                      <LockOutlinedIcon sx={{ ...colorWhite }} /> Change Password
                    </Box>
                  }
                  onChange={() => setOption("password")}
                  defaultExpanded={option === 'password'}
                >
                  <PasswordComponent updatePassword={updatePassword} />
                </LiqueAccordionControlled>
              </Box>
            </Grid>
            
            <Grid item xs={12} md={9} sx={{ display: { xs: "none", md: "block" } }} padding={3}>
              {
                option === 'profile' && (
                  <>
                    <Typography sx={{ ...subHeaderStyle }}>
                      My Profile
                    </Typography>
                    <ProfileComponent auth={auth} updateProfileFn={updateProfile}/>
                  </>
                )
              }

              {
                option === 'address' && (
                  <>
                    <Typography sx={{ ...subHeaderStyle }}>
                      Shipping Addresses
                    </Typography>
                    <AddressComponent />
                  </>
                )
              }
              
              {
                option === 'history' && (
                  <>
                    <Typography sx={{ ...subHeaderStyle }}>
                      My Orders
                    </Typography>
                    <HistoryComponent />
                  </>
                )
              }

              {
                option === 'password' && (
                  <>
                    <Typography sx={{ ...subHeaderStyle }}>
                      Change Password
                    </Typography>
                    <PasswordComponent updatePassword={updatePassword} />
                  </>
                )
              }
            </Grid>
          </Grid>
        </Container>
      </Box>

      <Footer />

      <LiqueModal open={addAddressDialog} onClose={handleCloseAddAddress}>
        <form>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Typography sx={{ ...fontSizeText }}>Address *</Typography>
              <TextField
                fullWidth
                autoComplete="off"
                value={selectedAddress}
                error={!!errors.address}
                helperText={errors.address}
                FormHelperTextProps={{ sx: { color: "red" } }}
                onChange={(e) => setSelectedAddress(e.target.value)}
                placeholder="Jl. Melati Mas..." // Add this line
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography sx={{ ...fontSizeText }}>Province *</Typography>
              <Autocomplete
                options={provinces} 
                getOptionLabel={(option) => option} 
                value={selectedProvince}
                onChange={(event, newValue) => {
                  setSelectedCity(null);
                  setSelectedSubDistrict(null);
                  setselectedNeighborhood(null);
                  setSelectedZipcode(null);

                  fetchCities(newValue);
                  setSelectedProvince(newValue);
                }}
                helperText={errors.selectedProvince}
                FormHelperTextProps={{ sx: { color: "red" } }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    margin="normal"
                    fullWidth
                    sx={{ 
                      '& .MuiInputBase-input': {
                        ...fontSizeText
                      },
                    }} 
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography sx={{ ...fontSizeText }}>City/Regency *</Typography>
              <Autocomplete
                options={cities}
                getOptionLabel={(option) => option}
                value={selectedCity}
                onChange={(event, newValue) => {
                  setSelectedSubDistrict(null);
                  setselectedNeighborhood(null);
                  setSelectedZipcode(null);

                  fetchSubDistricts(selectedProvince, newValue);
                  setSelectedCity(newValue);
                }}
                helperText={errors.selectedCity}
                FormHelperTextProps={{ sx: { color: "red" } }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    margin="normal"
                    fullWidth
                    sx={{ 
                      '& .MuiInputBase-input': {
                        ...fontSizeText
                      },
                    }} 
                  />
                )}
                disabled={selectedProvince === null}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography sx={{ ...fontSizeText }}>District *</Typography>
              <Autocomplete
                options={subDistricts} 
                getOptionLabel={(option) => option} 
                value={selectedSubDistrict}
                onChange={(event, newValue) => {
                  setselectedNeighborhood(null);
                  setSelectedZipcode(null);

                  fetchNeighborhoods(selectedProvince, selectedCity, newValue);
                  setSelectedSubDistrict(newValue);
                }}
                helperText={errors.selectedProvince}
                FormHelperTextProps={{ sx: { color: "red" } }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    margin="normal"
                    fullWidth
                    sx={{ 
                      '& .MuiInputBase-input': {
                        ...fontSizeText
                      },
                    }} 
                  />
                )}
                disabled={selectedCity === null}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography sx={{ ...fontSizeText }}>Sub-district/Village *</Typography>
              <Autocomplete
                options={neighborhoods}
                getOptionLabel={(option) => option}
                value={selectedNeighborhood}
                onChange={(event, newValue) =>{
                  setselectedNeighborhood(newValue)
                  fetchZipCode(selectedProvince, selectedCity, selectedSubDistrict, newValue)
                }}
                helperText={errors.selectedCity}
                FormHelperTextProps={{ sx: { color: "red" } }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    margin="normal"
                    fullWidth
                    sx={{ 
                      '& .MuiInputBase-input': {
                        ...fontSizeText
                      },
                    }} 
                  />
                )}
                disabled={selectedSubDistrict === null}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography sx={{ ...fontSizeText }}>Postal Code *</Typography>
              <Autocomplete
                options={zipcodes}
                getOptionLabel={(option) => option}
                value={selectedZipcode}
                onChange={(event, newValue) =>
                  setSelectedZipcode(newValue)
                }
                helperText={errors.selectedCity}
                FormHelperTextProps={{ sx: { color: "red" } }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    margin="normal"
                    fullWidth
                    sx={{ 
                      '& .MuiInputBase-input': {
                        ...fontSizeText
                      },
                    }} 
                  />
                )}
                disabled={selectedNeighborhood === null}
              />
            </Grid>
            <Grid item xs={12} md={6} alignSelf="center">
              <FormControlLabel control={<Checkbox checked={isDefault} onChange={(_event, checked) => setIsDefault(checked)}/>} 
                label="Set as default" sx={{ '& .MuiTypography-root': {...fontSizeText} }}/>
            </Grid>
            <Grid item xs={12}>
              <Typography sx={{ ...textStyleContrast }}>Notes</Typography>
              <TextareaAutosize
                style={{ width: "96%", borderRadius: '4px !important', marginTop: "10px" }}
                minRows={3}
                value={addressNotes}
                onChange={(e) => setAddressNotes(e.target.value)}
              />
              {!!errors.notes ? (
                <FormHelperText sx={{ color: "red" }}>
                  {errors.notes}
                </FormHelperText>
              ) : null}
            </Grid>
            <Grid item xs={12}>
              <Button
                onClick={submitAddress}
                fullWidth
                sx={{...btnStyleContrast}}
              >
                Submit
              </Button>
            </Grid>
          </Grid>
        </form>
      </LiqueModal>

      <LiqueModal open={openTrack} onClose={handleCloseTrack} theme="dark">
        <Box>
          <Grid container>
            <Grid item xs={8} display="flex" alignItems="center">
              <Typography sx={{ ...subHeaderStyle }}>Track Order</Typography>
            </Grid>
            <Grid item xs={4} display="flex" justifyContent="end">
              <Button sx={roudedIconButtonStyle} onClick={handleCloseTrack}>
                <CloseIcon />
              </Button>
            </Grid>
          </Grid>
          {
            selectedHistory && (
              <>
                <Box marginTop={2}>
                  <Grid container paddingBottom={5} sx={{ borderBottom: `1px solid ${lightgrayHex}` }}>
                    <Grid item xs={6} marginTop={1}>
                      <Typography sx={{ ...textStyle }}>
                        Shipping Date
                      </Typography>
                    </Grid>
                    <Grid item xs={6} marginTop={1} textAlign="end">
                      <Typography sx={{ ...textStyle }}>
                        {
                          selectedHistory.order.deliveryPickupDate ? format(new Date(selectedHistory.order.deliveryPickupDate), "dd MMMM yyy") : "Not Shipped Yet"
                        }
                      </Typography>
                    </Grid>
                    <Grid item xs={3} md={4} marginTop={1}>
                      <Typography sx={{ ...textStyle }}>
                        Order ID
                      </Typography>
                    </Grid>
                    <Grid item xs={9} md={8} marginTop={1}>
                      <Typography sx={{ ...textStyle }} textAlign="right">
                        {selectedHistory.order.id}
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid container marginTop={3} paddingBottom={5} sx={{ borderBottom: `1px solid ${lightgrayHex}` }}>
                    <Grid item xs={12}>
                      <Typography sx={{ ...textStyle, fontWeight: "bold" }}>Shipping Information</Typography>
                    </Grid>
                    <Grid item xs={6} marginTop={1}>
                      <Typography sx={{ ...textStyle }}>
                        Courier
                      </Typography>
                    </Grid>
                    <Grid item xs={6} marginTop={1} textAlign="end">
                      <Typography sx={{ ...textStyle }}>
                        J&T
                      </Typography>
                    </Grid>
                    <Grid item xs={6} marginTop={1}>
                      <Typography sx={{ ...textStyle }}>
                        Tracking Number
                      </Typography>
                    </Grid>
                    <Grid item xs={6} marginTop={1} textAlign="end">
                      <Typography sx={{ ...textStyle }}>
                        {selectedHistory.delivery?.awb || '-'}
                      </Typography>
                    </Grid>
                    {
                      selectedHistory.payment.length > 0 && (
                        <>
                          <Grid item xs={6} marginTop={1}>
                            <Typography sx={{ ...textStyle }}>
                              Address
                            </Typography>
                          </Grid>
                          <Grid item xs={6} marginTop={1} textAlign="end">
                            <Typography sx={{ ...textStyle }}>
                              {selectedHistory.order.username}, {selectedHistory.order.phoneNumber} <br/>
                              {selectedHistory.payment[0]?.address.detail}, {selectedHistory.payment[0]?.address.neighborhood}, {" "}
                              {selectedHistory.payment[0]?.address.subdistrict}, <br/> {selectedHistory.payment[0]?.address.district}, {" "}
                              {selectedHistory.payment[0]?.address.province}, {selectedHistory.payment[0]?.address.zipCode}
                            </Typography>
                          </Grid>
                        </>
                      )
                    }
                  </Grid>
                  <Grid container marginTop={3}>
                    <Grid item xs={12}>
                      <Typography sx={{ ...textStyle, fontWeight: "bold" }}>Tracking Details</Typography>
                    </Grid>
                    <Grid item xs={12} marginTop={2}>
                      {
                        trackData?.history ? (
                          <>
                            {
                              trackData.history.map((history, index) => (
                                <>
                                  <Grid container>
                                    <Grid item xs={4} md={2} textAlign="end">
                                      <Typography sx={{ ...textStyle }}>
                                        { format(new Date(history.dateTime), "iii, dd MMM yyyy") }
                                      </Typography>
                                      <Typography sx={{ ...textStyle }}>
                                        { format(new Date(history.dateTime), "HH.mm") } WIB
                                      </Typography>
                                    </Grid>
                                    <Grid item xs={2} md={1} display="flex" flexDirection="column" alignItems="center">
                                      <Box sx={{ width: "30px", height: "30px", borderRadius: "100px", background: index === 0 ? '#08B96A' : lightgrayHex, 
                                        display: "flex", justifyContent: "center", alignItems: "center" }}>
                                          <CheckIcon sx={{ color: "white" }} />
                                      </Box>
                                      {
                                        index !== trackData.history.length -1 && (
                                          <Box sx={{ width: "2px", height: "40px", background: lightgrayHex }}></Box>
                                        )
                                      }
                                    </Grid>
                                    <Grid item xs={6} md={9}>
                                      <Typography sx={{ ...textStyle }}>
                                        { history.status }
                                      </Typography>
                                    </Grid>
                                  </Grid>
                                </>
                              ))
                            }
                          </>
                        ) : (
                          <Grid item xs={12}>
                            <Typography sx={{ ...textStyle, textAlign: "center" }}>No data available</Typography>
                          </Grid>
                        )
                      }
                    </Grid>
                  </Grid>
                </Box>
              </>
            )
          }
        </Box>
      </LiqueModal>

      <LiqueModal open={openHistoryDetail} onClose={handleCloseHistoryDetail} theme="dark">
        <Box>
          <Grid container>
            <Grid item xs={8} display="flex" alignItems="center">
              <Typography sx={{ ...subHeaderStyle }}>Order Details</Typography>
            </Grid>
            <Grid item xs={4} display="flex" justifyContent="end">
              <Button sx={roudedIconButtonStyle} onClick={handleCloseHistoryDetail}>
                <CloseIcon />
              </Button>
            </Grid>
          </Grid>
          {
            selectedHistory && (
              <>
                <Box marginTop={2}>
                  <Grid container paddingBottom={5} sx={{ borderBottom: `1px solid ${lightgrayHex}` }}>
                    <Grid item xs={12}>
                      <Typography sx={{ ...textStyle, fontWeight: "bold" }}>{getStatustext(selectedHistory.order.status.key)}</Typography>
                    </Grid>
                    <Grid item xs={6} marginTop={1}>
                      <Typography sx={{ ...textStyle }}>
                        Transaction Date
                      </Typography>
                    </Grid>
                    <Grid item xs={6} marginTop={1} textAlign="end">
                      <Typography sx={{ ...textStyle }}>
                        {format(new Date(selectedHistory.order.createdDate), "dd MMMM yyy")}
                      </Typography>
                    </Grid>
                    <Grid item xs={3} md={4} marginTop={1}>
                      <Typography sx={{ ...textStyle }}>
                        Order ID
                      </Typography>
                    </Grid>
                    <Grid item xs={9} md={8} marginTop={1}>
                      <Typography sx={{ ...textStyle }} textAlign="right">
                        {selectedHistory.order.id}
                      </Typography>
                    </Grid>
                  </Grid>

                  <Box paddingBottom={4} marginTop={3} sx={{ borderBottom: `1px solid ${lightgrayHex}` }}>
                    <Typography sx={{ ...textStyle, fontWeight: "bold" }}>Product Details</Typography>

                    <Box marginTop={1}>
                      {
                        selectedHistory.order.itemList.map((item, index) => (
                          <React.Fragment key={index}>
                            <Grid item xs={12} marginBottom={2}>
                              <Grid container columnSpacing={2}>
                                <Grid item marginBottom={1} xs={12} md={1}>
                                  <Box sx={{ 
                                    width: "100%",
                                    maxWidth: "80px",
                                    aspectRatio: "1 / 1",
                                    borderRadius: "16px",
                                    overflow: "hidden"
                                  }}>
                                    <img
                                      src={
                                        item.images?.length <= 0 || item.images == null
                                          ? noImage
                                          : `${imageUrl}${item.images[0]}`
                                      }
                                      alt={item.name}
                                      style={{
                                        width: "100%",
                                        objectFit: "cover",
                                        marginRight: "3%"
                                      }}
                                    ></img>
                                  </Box>
                                </Grid>
            
                                <Grid item marginBottom={1} xs={12} md={9}>
                                  {
                                    item.brand && (
                                      <>
                                        <img 
                                          src={item.brand?.images == null ? noImage : `${imageUrl}${item.brand?.images[0]}`}
                                          alt={item.brand.title}
                                          style={{ width: "70px", aspectRatio: "1 / 1", objectFit: "contain" }}
                                        />
                                      </>
                                    )
                                  }
                                  <Typography sx={{ ...textStyle }}>
                                    {item.name}, Size: {item.variant?.size}
                                  </Typography>
                                  <Box display="flex" flexWrap="wrap" gap="10px" alignItems="center">
                                    <Typography sx={{ ...textStyle, fontWeight: "bold" }}>
                                      Total: {item.quantity} - {" "}
                                      <NumericFormat
                                        value={item.price - item.discountValue}
                                        displayType={"text"}
                                        thousandSeparator="."
                                        decimalSeparator=","
                                        prefix={"RP "}
                                      />
                                    </Typography>
                                    {
                                      item.useDiscount && (
                                        <Box display="flex" gap="10px" alignItems="center">
                                          <Typography sx={{ ...textSmallStyle, color: lightergrayHex, textDecoration: "line-through" }}>
                                            <NumericFormat
                                              value={item.price}
                                              displayType={"text"}
                                              thousandSeparator="."
                                              decimalSeparator=","
                                              prefix={"Rp. "}
                                            />
                                          </Typography>
                                          <Box sx={{ background: discountHex, padding: "2px 5px" }}>
                                            <Typography sx={{ ...textSmallStyle }}>
                                              <NumericFormat
                                                value={item.discountPercent}
                                                displayType={"text"}
                                                thousandSeparator="."
                                                decimalSeparator=","
                                                suffix='%'
                                              />
                                            </Typography>
                                          </Box>
                                        </Box>
                                      )
                                    }
                                  </Box>
                                </Grid>
            
                                <Grid item marginBottom={1} xs={12} md={2} textAlign="end">
                                  {
                                    (selectedHistory.order.status.key !== "WAITING_FOR_PAYMENT" && item.active) && (
                                      <Button sx={{ ...btnStyleOutlined, borderRadius: "50px", width: "100%" }} onClick={() => navigate(`/item/${item.slug}`)}>
                                        Buy Again
                                      </Button>
                                    )
                                  }
                                </Grid>
                              </Grid>
                            </Grid>
                          </React.Fragment>
                        ))
                      }
                    </Box>
                  </Box>

                  <Grid container marginTop={3} paddingBottom={5} sx={{ borderBottom: `1px solid ${lightgrayHex}` }}>
                    <Grid item xs={12}>
                      <Typography sx={{ ...textStyle, fontWeight: "bold" }}>Shipping Information</Typography>
                    </Grid>
                    <Grid item xs={6} marginTop={1}>
                      <Typography sx={{ ...textStyle }}>
                        Courier
                      </Typography>
                    </Grid>
                    <Grid item xs={6} marginTop={1} textAlign="end">
                      <Typography sx={{ ...textStyle }}>
                        J&T
                      </Typography>
                    </Grid>
                    <Grid item xs={6} marginTop={1}>
                      <Typography sx={{ ...textStyle }}>
                        Tracking Number
                      </Typography>
                    </Grid>
                    <Grid item xs={6} marginTop={1} textAlign="end">
                      <Typography sx={{ ...textStyle }}>
                        {selectedHistory.delivery?.awb}
                      </Typography>
                    </Grid>
                    {
                      selectedHistory.payment.length > 0 && (
                        <>
                          <Grid item xs={6} marginTop={1}>
                            <Typography sx={{ ...textStyle }}>
                              Address
                            </Typography>
                          </Grid>
                          <Grid item xs={6} marginTop={1} textAlign="end">
                            <Typography sx={{ ...textStyle }}>
                              {selectedHistory.order.username}, {selectedHistory.order.phoneNumber} <br/>
                              {selectedHistory.payment[0]?.address.detail}, {selectedHistory.payment[0]?.address.neighborhood}, {" "}
                              {selectedHistory.payment[0]?.address.subdistrict}, <br/> {selectedHistory.payment[0]?.address.district}, {" "}
                              {selectedHistory.payment[0]?.address.province}, {selectedHistory.payment[0]?.address.zipCode}
                            </Typography>
                          </Grid>
                        </>
                      )
                    }
                  </Grid>
                  
                  {
                    selectedHistory.payment.length > 0 && (
                      <>
                        <Grid container marginTop={3} paddingBottom={5} sx={{ borderBottom: `1px solid ${lightgrayHex}` }}>
                          <Grid item xs={12}>
                            <Typography sx={{ ...textStyle, fontWeight: "bold" }}>Payment Details</Typography>
                          </Grid>
                          <Grid item xs={6} marginTop={1}>
                            <Typography sx={{ ...textStyle }}>
                              Payment Method
                            </Typography>
                          </Grid>
                          <Grid item xs={6} marginTop={1} textAlign="end">
                            <Typography sx={{ ...textStyle }}>
                              {getPembayaran(selectedHistory.payment[0])}
                            </Typography>
                          </Grid>
                          <Grid item xs={6} marginTop={1}>
                            <Typography sx={{ ...textStyle }}>
                              Product Subtotal
                            </Typography>
                          </Grid>
                          <Grid item xs={6} marginTop={1} textAlign="end">
                            <Typography sx={{ ...textStyle }}>
                              <NumericFormat value={selectedHistory.order.price} displayType={"text"}
                                thousandSeparator="." decimalSeparator="," prefix={"Rp. "}/>
                            </Typography>
                          </Grid>
                          <Grid item xs={6} marginTop={1}>
                            <Typography sx={{ ...textStyle }}>
                              Total Shipping Cost
                            </Typography>
                          </Grid>
                          <Grid item xs={6} marginTop={1} textAlign="end">
                            <Typography sx={{ ...textStyle }}>
                              <NumericFormat value={selectedHistory.order.paymentDeliveryFee} displayType={"text"}
                                thousandSeparator="." decimalSeparator="," prefix={"Rp. "}/>
                            </Typography>
                          </Grid>
                          <Grid item xs={6} marginTop={1}>
                            <Typography sx={{ ...textStyle }}>
                              Discount
                            </Typography>
                          </Grid>
                          <Grid item xs={6} marginTop={1} textAlign="end">
                            <Typography sx={{ ...textStyle }}>
                              <NumericFormat value={selectedHistory.order.discount || 0} displayType={"text"}
                                thousandSeparator="." decimalSeparator="," allowNegative={false} 
                                prefix={(selectedHistory.order.discount || 0) <= 0 ? "Rp. " : "-Rp. "}/>
                            </Typography>
                          </Grid>
                          <Grid item xs={6} marginTop={1}>
                            <Typography sx={{ ...textStyle }}>
                              Admin Fee
                            </Typography>
                          </Grid>
                          <Grid item xs={6} marginTop={1} textAlign="end">
                            <Typography sx={{ ...textStyle }}>
                              <NumericFormat value={selectedHistory.order.paymentTransactionFee} displayType={"text"}
                                thousandSeparator="." decimalSeparator="," prefix={"Rp. "}/>
                            </Typography>
                          </Grid>
                        </Grid>

                        <Grid container marginTop={3}>
                          <Grid item xs={6}>
                            <Typography sx={{ ...textStyle, fontWeight: "bold" }}>Total Price</Typography>
                          </Grid>
                          <Grid item xs={6} textAlign="end">
                            <Typography sx={{ ...textStyle, fontWeight: "bold" }}>
                              <NumericFormat value={selectedHistory.order.subTotal} displayType={"text"}
                                thousandSeparator="." decimalSeparator="," prefix={"Rp. "}/>
                            </Typography>
                          </Grid>
                        </Grid>
                      </>
                      
                    )
                  }

                  {
                    selectedHistory?.order.status.key === "WAITING_FOR_PAYMENT" && (
                      <Grid container justifyContent="end" marginTop={5}>
                        <Grid item xs={12} md={6} lg={3}>
                          <Button
                            sx={{ ...btnStyleContrast, background: redHex, borderRadius: "50px", width: "100%" }}
                            onClick={() => setOpenDelete(true)}
                            disabled={loadingDelete}
                          >
                            Cancel Order
                          </Button>
                        </Grid>
                      </Grid>
                    )
                  }
                </Box>
              </>
            )
          }
        </Box>
      </LiqueModal>

      <LiqueModal open={openPay} onClose={handleClosePay} theme="dark" width="700px">
        <Box>
          <Typography sx={{ ...subHeaderStyle }} marginBottom={3}>Pay Order</Typography>
          <Grid container>
            <Grid item xs={12} marginBottom={2}>
              <Typography sx={{ ...textSmallStyle }}>Total Payment</Typography>
              <Typography variant="h5" sx={{ textAlign: "left", ...headerStyle }}>
                <NumericFormat
                  value={selectedHistory?.payment[0]?.totalPrice}
                  displayType={"text"}
                  thousandSeparator="."
                  decimalSeparator=","
                  prefix={" Rp. "}
                />
              </Typography>
            </Grid>
          {
            (selectedHistory?.order.status.key === 'WAITING_FOR_PAYMENT' && selectedHistory?.payment[0]?.method === 'EWALLET') && (
              <>
                {
                  selectedHistory?.payment[0]?.channel === 'OVO' ? (
                    <Grid item xs={12} marginBottom={2}>
                      <Typography sx={{ ...textSmallStyle }}>Check your OVO application to make the payment</Typography>
                    </Grid>
                  ) : (
                    <Grid item xs={12}>
                      <Typography sx={{ ...textSmallStyle }}>
                        Payment Link
                      </Typography>
                      <Typography sx={{ ...subHeaderStyle }}>
                        <a href={selectedHistory?.payment[0]?.paymentLink} rel="noreferrer" target="_blank">Click Here</a>
                      </Typography>
                    </Grid>
                  )
                }
              </>
            )
          }
          {
            (selectedHistory?.order.status.key === 'WAITING_FOR_PAYMENT' && selectedHistory?.payment[0]?.method === 'VIRTUAL_ACCOUNT') && (
              <>
                <Grid item xs={12}>
                  <Typography sx={{ ...textSmallStyle }}>{ getPembayaran(selectedHistory.payment[0]) } Number</Typography>
                  <Typography variant="h5" sx={{ textAlign: "left", ...headerStyle }}>
                    {selectedHistory?.payment[0]?.virtualAccountNumber}
                  </Typography>
                </Grid>
              </>
            )
          }
          {
            (selectedHistory?.order.status.key === 'WAITING_FOR_PAYMENT' && selectedHistory?.payment[0]?.method === 'QR_CODE') && (
              <>
                <Grid item xs={12} textAlign="center">
                  <Box sx={{ width: "fit-content", background: "white", padding: "5px", marginX: "auto" }} marginBottom={1}>
                    <QRCodeCanvas value={selectedHistory?.payment[0]?.qrCode} size={256} />
                  </Box>
                  <Typography sx={{ ...textSmallStyle }}>Scan the QR Code above to make the payment</Typography>
                </Grid>
                {/* <Grid item xs={6} md={12} marginTop={1}>
                  <Typography sx={{ ...textStyle }}>
                    QR Code
                  </Typography>
                </Grid>
                <Grid item xs={6} md={12} marginTop={1} justifyContent="end" sx={{ display: {xs: "none", md: "flex"} }}>
                  <Box sx={{ width: "fit-content", background: "white", padding: "5px" }}>
                    <QRCodeCanvas value={selectedHistory?.payment[0]?.qrCode} size={256} />
                  </Box>
                </Grid>
                <Grid item xs={6} md={12} marginTop={1} justifyContent="end" sx={{ display: {xs: "flex", md: "none"} }}>
                  <Box sx={{ width: "fit-content", background: "white", padding: "5px" }}>
                    <QRCodeCanvas value={selectedHistory?.payment[0]?.qrCode} size={180} />
                  </Box>
                </Grid> */}
              </>
            )
          }
            <Grid item xs={12} display="flex" justifyContent="end" marginTop={3}>
              <Button sx={{ ...btnStyle, borderRadius: "50px", width: "250px" }} onClick={() => handleOpenChangePaymentMethod(selectedHistory?.payment[0])}>
                Change Payment Method
              </Button>
            </Grid>
          </Grid>
        </Box>
      </LiqueModal>

      <LiqueModal open={paymentMethodDialog} onClose={handleCloseChangePaymentMethod} theme="dark" width="700px">
        <Box>
          <Grid container marginTop={3} paddingBottom={5} sx={{ borderBottom: `1px solid ${lightgrayHex}` }}>
            <Grid item xs={12}>
              <Typography sx={{ ...textStyle, fontWeight: "bold" }}>Payment Details</Typography>
            </Grid>
            <Grid item xs={6} marginTop={1}>
              <Typography sx={{ ...textStyle }}>
                Payment Method
              </Typography>
            </Grid>
            <Grid item xs={6} marginTop={1} textAlign="end">
              <Typography sx={{ ...textStyle }}>
                {getPembayaran({ method: paymentMethod, channel: paymentChannel })}
              </Typography>
            </Grid>
            <Grid item xs={6} marginTop={1}>
              <Typography sx={{ ...textStyle }}>
                Product Subtotal
              </Typography>
            </Grid>
            <Grid item xs={6} marginTop={1} textAlign="end">
              <Typography sx={{ ...textStyle }}>
                <NumericFormat value={subTotal} displayType={"text"}
                  thousandSeparator="." decimalSeparator="," prefix={"Rp. "}/>
              </Typography>
            </Grid>
            <Grid item xs={6} marginTop={1}>
              <Typography sx={{ ...textStyle }}>
                Total Shipping Cost
              </Typography>
            </Grid>
            <Grid item xs={6} marginTop={1} textAlign="end">
              <Typography sx={{ ...textStyle }}>
                <NumericFormat value={deliveryFee} displayType={"text"}
                  thousandSeparator="." decimalSeparator="," prefix={"Rp. "}/>
              </Typography>
            </Grid>
            <Grid item xs={6} marginTop={1}>
              <Typography sx={{ ...textStyle }}>
                Discount
              </Typography>
            </Grid>
            <Grid item xs={6} marginTop={1} textAlign="end">
              <Typography sx={{ ...textStyle }}>
                <NumericFormat value={discount || 0} displayType={"text"}
                  thousandSeparator="." decimalSeparator="," allowNegative={false} 
                  prefix={(discount || 0) <= 0 ? "Rp. " : "-Rp. "}/>
              </Typography>
            </Grid>
            <Grid item xs={6} marginTop={1}>
              <Typography sx={{ ...textStyle }}>
                Admin Fee
              </Typography>
            </Grid>
            <Grid item xs={6} marginTop={1} textAlign="end">
              <Typography sx={{ ...textStyle }}>
                <NumericFormat value={transactionFee} displayType={"text"}
                  thousandSeparator="." decimalSeparator="," prefix={"Rp. "}/>
              </Typography>
            </Grid>
          </Grid>

          <Grid container marginTop={3}>
            <Grid item xs={6}>
              <Typography sx={{ ...textStyle, fontWeight: "bold" }}>Total Price</Typography>
            </Grid>
            <Grid item xs={6} textAlign="end">
              <Typography sx={{ ...textStyle, fontWeight: "bold" }}>
                <NumericFormat value={total} displayType={"text"}
                  thousandSeparator="." decimalSeparator="," prefix={"Rp. "}/>
              </Typography>
            </Grid>
          </Grid>

          <Grid container marginTop={3}>
            <Grid item xs={12}>
              <Box onClick={() => setEwalletDialog(true)} sx={{cursor: "pointer"}}>
                <Grid container alignItems="center">
                  <Grid item xs={2} md={1}>
                    <Radio sx={radioStyle} disabled checked={paymentMethod === "EWALLET"}/>
                  </Grid>
                  <Grid item xs={4} md={3} sx={{ ...textStyle }}>
                    E-Wallet
                  </Grid>
                  <Grid item xs={6} md={8} sx={{ display: "flex", alignItems: "center", justifyContent: "end", flexWrap: "wrap" }}>
                    <img src={logoDana} alt="Dana Logo" width={60} style={{ paddingRight: "10px" }} />
                    <img src={logoOvo} alt="OVO Logo" width={60} style={{ paddingRight: "10px" }} />
                  </Grid>
                </Grid>
              </Box>

              <Box onClick={() => setVirtualAccountDialog(true)} sx={{cursor: "pointer"}}>
                <Grid container alignItems="center">
                  <Grid item xs={2} md={1}>
                    <Radio sx={radioStyle} disabled checked={paymentMethod === "VIRTUAL_ACCOUNT"}/>
                  </Grid>
                  <Grid item xs={4} md={3} sx={{ ...textStyle }}>
                    Virtual Account
                  </Grid>
                  <Grid item xs={6} md={8} sx={{ display: "flex", alignItems: "center", justifyContent: "end", flexWrap: "wrap" }}>
                    <img src={logoMandiri} alt="Mandiri Logo" width={45} style={{ paddingRight: "10px" }}/>
                    <img src={logoBri} alt="BRI Logo" width={45} style={{ paddingRight: "10px" }}/>
                    <img src={logoBni} alt="BNI Logo" width={45} style={{ paddingRight: "10px" }} />
                    <img src={logoCimb} alt="CIMB Logo" width={45} style={{ paddingRight: "10px" }} />
                    <img src={logoPermata} alt="Permata Logo" width={45} style={{ paddingRight: "10px" }} />
                    <img src={logoSampoerna} alt="Sampoerna Logo" width={45} style={{ paddingRight: "10px" }} />
                    <img src={logoBjb} alt="BJB Logo" width={45} style={{ paddingRight: "10px" }} />
                    <img src={logoBsi} alt="BSI Logo" width={45} style={{ paddingRight: "10px" }} />
                  </Grid>
                </Grid>
              </Box>

              <Box onClick={() => setPaymentData("QR_CODE", "QRIS")} sx={{cursor: "pointer"}}>
                <Grid container alignItems="center">
                  <Grid item xs={2} md={1}>
                    <Radio sx={radioStyle} disabled checked={paymentMethod === "QR_CODE"}/>
                  </Grid>
                  <Grid item xs={4} md={3} sx={{ ...textStyle }}>
                    QRIS
                  </Grid>
                  <Grid item xs={6} md={8} sx={{ display: "flex", alignItems: "center", justifyContent: "end", flexWrap: "wrap" }}>
                    <img src={logoQris} alt="QRIS Logo" width={45} style={{ paddingRight: "10px" }} />
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          </Grid>

          <Box display="flex" justifyContent="end" marginTop={3}>
            <Button sx={{ ...btnStyle, borderRadius: "50px", width: "250px" }} onClick={changePaymentMethod} disabled={loadingUpdateMethod}>
              { loadingUpdateMethod ? 'Please wait...' : 'Update Payment Method' }
            </Button>
          </Box>
        </Box>
      </LiqueModal>

      <LiqueModal open={openDelete} onClose={() => setOpenDelete(false)} theme="dark" width="600px">
        <Box textAlign="center">
          <Typography sx={{ ...textStyle, fontWeight: "bold" }}>
            Are you sure you want to cancel the order for this product?
          </Typography>
          <Grid container columnSpacing={1} marginTop={3}>
            <Grid item xs={6}>
              <Button
                onClick={() => setOpenDelete(false)}
                sx={{ ...btnStyleOutlined, borderRadius: "50px", width: "100%" }}
              >
                No
              </Button>
            </Grid>
            <Grid item xs={6}>
              <Button
                sx={{ ...btnStyleContrast, background: redHex, borderRadius: "50px", width: "100%" }}
                onClick={deleteItem}
                disabled={loadingDelete}
              >
                {loadingDelete ? 'Please wait...' : 'Cancel Order'}
              </Button>
            </Grid>
          </Grid>
        </Box>
      </LiqueModal>

      <LiqueModal open={ewalletDialog} onClose={() => setEwalletDialog(false)}>
        <Box onClick={() => setEwalletPaymentData("DANA")}
          sx={{
            ...methodItemStyle,
            border:
              paymentChannel === "DANA"
                ? "4px solid rgb(254, 138, 1)"
                : "2px solid black",
          }}
        >
          <Grid container sx={{ textAlign: "left", padding: "20px", }}>
            <Grid item xs={8} sx={{ display: "flex", alignItems: "center" }}>
              DANA
            </Grid>
            <Grid item xs={4} sx={{ display: "flex", alignItems: "center" }}>
              <img src={logoDana} alt="Dana Logo"
                width={120} style={{ transition: "background-color 0.3s", maxWidth: "100%" }}/>
            </Grid>
          </Grid>
        </Box>

        <Box onClick={() => setEwalletPaymentData("OVO")}
          sx={{
            ...methodItemStyle,
            border:
              paymentChannel === "OVO"
                ? "4px solid rgb(254, 138, 1)"
                : "2px solid black",
          }}
        >
          <Grid container sx={{ textAlign: "left", padding: "20px", }}>
            <Grid item xs={8} sx={{ display: "flex", alignItems: "center" }}>
              OVO
            </Grid>
            <Grid item xs={4} sx={{ display: "flex", alignItems: "center" }}>
              <img src={logoOvo} alt="OVO Logo"
                width={120} style={{ transition: "background-color 0.3s", maxWidth: "100%"  }}/>
            </Grid>
          </Grid>
        </Box>
      </LiqueModal>

      <LiqueModal open={virtualAccountDialog} onClose={() => setVirtualAccountDialog(false)}>
        <Box onClick={() => setVAPaymentData("MANDIRI")}
          sx={{
            ...methodItemStyle,
            border:
              paymentChannel === "MANDIRI"
                ? "4px solid rgb(254, 138, 1)"
                : "2px solid black",
          }}
        >
          <Grid container sx={{ textAlign: "left", padding: "20px", }}>
            <Grid item xs={8} sx={{ display: "flex", alignItems: "center" }}>
              Mandiri Virtual Account
            </Grid>
            <Grid item xs={4} sx={{ display: "flex", alignItems: "center" }}>
              <img src={logoMandiri} alt="Mandiri Logo"
                width={120} style={{ transition: "background-color 0.3s", maxWidth: "100%"  }}/>
            </Grid>
          </Grid>
        </Box>

        <Box onClick={() => setVAPaymentData("BRI")}
          sx={{
            ...methodItemStyle,
            border:
              paymentChannel === "BRI"
                ? "4px solid rgb(254, 138, 1)"
                : "2px solid black",
          }}
        >
          <Grid container sx={{ textAlign: "left", padding: "20px", }}>
            <Grid item xs={8} sx={{ display: "flex", alignItems: "center" }}>
              BRI Virtual Account
            </Grid>
            <Grid item xs={4} sx={{ display: "flex", alignItems: "center" }}>
              <img src={logoBri} alt="BRI Logo"
                width={120} style={{ transition: "background-color 0.3s", maxWidth: "100%"  }}/>
            </Grid>
          </Grid>
        </Box>

        <Box onClick={() => setVAPaymentData("BNI")}
          sx={{
            ...methodItemStyle,
            border:
              paymentChannel === "BNI"
                ? "4px solid rgb(254, 138, 1)"
                : "2px solid black",
          }}
        >
          <Grid container sx={{ textAlign: "left", padding: "20px", }}>
            <Grid item xs={8} sx={{ display: "flex", alignItems: "center" }}>
              BNI Virtual Account
            </Grid>
            <Grid item xs={4} sx={{ display: "flex", alignItems: "center" }}>
              <img src={logoBni} alt="BNI Logo"
                width={120} style={{ transition: "background-color 0.3s", maxWidth: "100%"  }}/>
            </Grid>
          </Grid>
        </Box>

        <Box onClick={() => setVAPaymentData("CIMB")}
          sx={{
            ...methodItemStyle,
            border:
              paymentChannel === "CIMB"
                ? "4px solid rgb(254, 138, 1)"
                : "2px solid black",
          }}
        >
          <Grid container sx={{ textAlign: "left", padding: "20px", }}>
            <Grid item xs={8} sx={{ display: "flex", alignItems: "center" }}>
              CIMB Virtual Account
            </Grid>
            <Grid item xs={4} sx={{ display: "flex", alignItems: "center" }}>
              <img src={logoCimb} alt="CIMB Logo"
                width={120} style={{ transition: "background-color 0.3s", maxWidth: "100%"  }}/>
            </Grid>
          </Grid>
        </Box>

        <Box onClick={() => setVAPaymentData("PERMATA")}
          sx={{
            ...methodItemStyle,
            border:
              paymentChannel === "PERMATA"
                ? "4px solid rgb(254, 138, 1)"
                : "2px solid black",
          }}
        >
          <Grid container sx={{ textAlign: "left", padding: "20px", }}>
            <Grid item xs={8} sx={{ display: "flex", alignItems: "center" }}>
              Permata Virtual Account
            </Grid>
            <Grid item xs={4} sx={{ display: "flex", alignItems: "center" }}>
              <img src={logoPermata} alt="PERMATA Logo"
                width={120} style={{ transition: "background-color 0.3s", maxWidth: "100%"  }}/>
            </Grid>
          </Grid>
        </Box>

        <Box onClick={() => setVAPaymentData("SAHABAT_SAMPOERNA")}
          sx={{
            ...methodItemStyle,
            border:
              paymentChannel === "SAHABAT_SAMPOERNA"
                ? "4px solid rgb(254, 138, 1)"
                : "2px solid black",
          }}
        >
          <Grid container sx={{ textAlign: "left", padding: "20px", }}>
            <Grid item xs={8} sx={{ display: "flex", alignItems: "center" }}>
              Sampoerna Virtual Account
            </Grid>
            <Grid item xs={4} sx={{ display: "flex", alignItems: "center" }}>
              <img src={logoSampoerna} alt="SAHABAT_SAMPOERNA Logo"
                width={120} style={{ transition: "background-color 0.3s", maxWidth: "100%"  }}/>
            </Grid>
          </Grid>
        </Box>

        <Box onClick={() => setVAPaymentData("BJB")}
          sx={{
            ...methodItemStyle,
            border:
              paymentChannel === "BJB"
                ? "4px solid rgb(254, 138, 1)"
                : "2px solid black",
          }}
        >
          <Grid container sx={{ textAlign: "left", padding: "20px", }}>
            <Grid item xs={8} sx={{ display: "flex", alignItems: "center" }}>
              BJB Virtual Account
            </Grid>
            <Grid item xs={4} sx={{ display: "flex", alignItems: "center" }}>
              <img src={logoBjb} alt="BJB Logo"
                width={120} style={{ transition: "background-color 0.3s", maxWidth: "100%"  }}/>
            </Grid>
          </Grid>
        </Box>

        <Box onClick={() => setVAPaymentData("BSI")}
          sx={{
            ...methodItemStyle,
            border:
              paymentChannel === "BSI"
                ? "4px solid rgb(254, 138, 1)"
                : "2px solid black",
          }}
        >
          <Grid container sx={{ textAlign: "left", padding: "20px", }}>
            <Grid item xs={8} sx={{ display: "flex", alignItems: "center" }}>
              BSI Virtual Account
            </Grid>
            <Grid item xs={4} sx={{ display: "flex", alignItems: "center" }}>
              <img src={logoBsi} alt="BSI Logo"
                width={120} style={{ transition: "background-color 0.3s", maxWidth: "100%"  }}/>
            </Grid>
          </Grid>
        </Box>
      </LiqueModal>
    </>
  );
}

export default ProfilePage;